// Modules
import { api } from "services/api/service";

// Constants
import { API_GET_CR_TRANSACTION, API_VOID_CR_TRANSACTION } from "constants/api";

// Imported definitions
import type { ApiResponse, GetCRTransactionResponse, VoidCRTransactionResponse } from "services/api/types";

export const getCRTransaction = async (payload: { pos_transaction_id: string }): Promise<ApiResponse<GetCRTransactionResponse>> => {
	return (await api()).post(API_GET_CR_TRANSACTION, payload);
};

export const voidCRTransaction = async (outletCode: string, uid: string, receiptNo: string, transactionDateTimeUTC: string): Promise<ApiResponse<VoidCRTransactionResponse>> => {
	const updatedPayload = {
		outlet_code: outletCode,
		uid: uid,
		receipt_no: receiptNo,
		transaction_date_time_utc: transactionDateTimeUTC
	};

	return (await api()).post(API_VOID_CR_TRANSACTION, updatedPayload);
};
